export const DH = {
    LOADER: 'LOADER',
    ROW_SEATS: 'ROW_SEATS',
    MULTI_ROW_ROW: 'MULTI_ROW_ROW',
    MULTI_ROW_ROW_SEATS: 'MULTI_ROW_ROW_SEATS',
    SHAPE_MEASURING_RECT: 'SHAPE_MEASURING_RECT',
    POINTER_AREA: 'POINTER_AREA',
    RESERVED_AREA: 'RESERVED_AREA',
    STAGE: 'STAGE',
};
//# sourceMappingURL=data-hooks.js.map